import gql from 'graphql-tag';

export const GET_STAY_INFORMATION_WILL_ALL_LOCALES = gql`
  fragment CommonStayInformationFields on StayInformation {
    id
    title
    content
    locale
    hidden
    bannerImage {
      id
      url
      formats
    }
    size
    externalBannerImage
    parentStayInfo {
      id
    }
  }
  query GetStayInformationWithAllLocales($id: ID!) {
    stayInformation(id: $id) {
      ...CommonStayInformationFields
      localizations {
        ...CommonStayInformationFields
      }
    }
  }
`;
